import * as Types from './types';
import { Dispatch } from 'redux';
import { IAction, IActionMethods, StateStatus } from 'redux/utils/common';
import * as CategoryService from 'services/api/category';
import * as ProductService from 'services/api/product';
import * as SpecificationAttribute from 'services/api/specificationattribute';
import { IFiltersSelection } from './reducer';
import { IMiniProfile } from 'services/api/product';
import { LanguagesEnum } from 'constants/languages';
import * as CityService from 'services/api/city';
import * as MunicipalityService from 'services/api/municipality';
import * as SpecificationAttributeService from 'services/api/specificationattribute';
import * as ClientService from 'services/api/client';
import * as ZonesService from 'services/api/zones';

/* Fetch all categories */
class FetchCategory implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_CATEGORY,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_CATEGORY,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_CATEGORY,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await CategoryService.fetchAllCategories();
        dispatch(this.onSuccess(response.data));
      } catch (error) {
        console.log('Fetch categories error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

/* Set filters selection */
class SetFiltersSelection implements IActionMethods {
  onFailed(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onPending(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onSuccess(data: IFiltersSelection): IAction {
    return {
      type: Types.SET_FILTERS_SELECTION,
      status: StateStatus.Success,
      data: data,
    };
  }

  action(data: IFiltersSelection): any {
    return async (dispatch: Dispatch<any>) => {
      dispatch(this.onSuccess(data));
    };
  }
}

// Reset Store
class ResetStore implements IActionMethods {
  onFailed(): IAction {
    throw new Error('Method not implemented.');
  }
  onPending(): IAction {
    throw new Error('Method not implemented.');
  }
  onSuccess(): IAction {
    return {
      type: Types.RESET_STORE,
      status: StateStatus.Success,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      dispatch(this.onSuccess());
    };
  }
}

/* Fetch all agents */
class FetchAgents implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_AGENTS,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: Array<IMiniProfile>): IAction {
    return {
      type: Types.SET_AGENTS,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_AGENTS,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await ProductService.fetchAgents();
        dispatch(this.onSuccess(response.data));
      } catch (error) {
        console.log('Fetch agents error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class FetchCustomAttributes implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_CUSTOM_ATTRIBUTES,
      status: StateStatus.Pending,
      data: [],
    };
  }
  onSuccess(
    data: Array<SpecificationAttribute.ICustomSpecificationAttribute>
  ): IAction {
    return {
      type: Types.SET_CUSTOM_ATTRIBUTES,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_CUSTOM_ATTRIBUTES,
      status: StateStatus.Failed,
      data: [],
    };
  }

  action(lan: LanguagesEnum): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response =
          await SpecificationAttributeService.fetchSpecificationAttributeListAll(
            lan,
            true,
            'Product'
          );
        dispatch(this.onSuccess(response.data?.items));
      } catch (error) {
        console.log('Fetch custom filtered attributes error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class FetchCity implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_CITY,
      status: StateStatus.Pending,
      data: null,
    };
  }
  onSuccess(data: Array<CityService.ICity>): IAction {
    return {
      type: Types.SET_CITY,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_CITY,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(language: LanguagesEnum): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await CityService.fetchAllCities(language);
        dispatch(this.onSuccess(response.data));
      } catch (error) {
        console.log('Set City Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class FetchMunicipality implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_MUNICIPALITY,
      status: StateStatus.Pending,
      data: null,
    };
  }
  onSuccess(data: Array<MunicipalityService.IMunicipality>): IAction {
    return {
      type: Types.SET_MUNICIPALITY,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_MUNICIPALITY,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(language: LanguagesEnum): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await MunicipalityService.fetchAllMunicipalities(
          language
        );
        dispatch(this.onSuccess(response.data));
      } catch (error) {
        console.log('Set Municipality Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class FetchSegments implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_SEGMENTS,
      status: StateStatus.Pending,
      data: null,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_SEGMENTS,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_SEGMENTS,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: { language: LanguagesEnum }): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await ProductService.fetchBasicInfoSegments(
          payload.language
        );
        dispatch(this.onSuccess(response.data));
      } catch (error) {
        console.log('Set Segments Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class FetchClientCustomers implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_CLIENT_CUSTOMERS,
      status: StateStatus.Pending,
      data: null,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_CLIENT_CUSTOMERS,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_CLIENT_CUSTOMERS,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await ClientService.fetchCustomers();
        dispatch(this.onSuccess(response.data));
      } catch (error) {
        console.log('Fetch client Customers Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class FetchZoneList implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.GET_LIST_ZONES,
      status: StateStatus.Pending,
      data: null,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.GET_LIST_ZONES,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.GET_LIST_ZONES,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await ZonesService.fetchZonesList();
        dispatch(this.onSuccess(response.data));
      } catch (error) {
        console.log('fetchZonesList', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

export default {
  fetchCategoryAction: () => new FetchCategory().action(),
  fetchAgentsAction: () => new FetchAgents().action(),
  setFiltersSelectionAction: (data: IFiltersSelection) =>
    new SetFiltersSelection().action(data),
  resetStoreAction: () => new ResetStore().action(),
  setCustomFilteredSpecs: (lan: LanguagesEnum) =>
    new FetchCustomAttributes().action(lan),
  fetchCity: (language: LanguagesEnum) => new FetchCity().action(language),
  fetchMunicipality: (language: LanguagesEnum) =>
    new FetchMunicipality().action(language),
  fetchSegmentsAction: (payload: { language: LanguagesEnum }) =>
    new FetchSegments().action(payload),
  fetchClientCustomersAction: () => new FetchClientCustomers().action(),
  fetchZoneListAction: () => new FetchZoneList().action(),
};
